import React from "react";
import { useTranslation } from "react-i18next";

import { PlacesQueryStatus } from "../../../../../models/PlacesQueryData";

import "./styles.scss";

export interface IStatusBadgeProps {
  status: PlacesQueryStatus;
  errorMessage?: string | null;
}

export const StatusBadge: React.FunctionComponent<IStatusBadgeProps> = ({
  status,
  errorMessage,
}) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`internalToolsHomePage.gbp_places_query.status.${key}`);

  if (status === "completed" && errorMessage) {
    return (
      <span className="status-badge status-completed-with-note">
        {t("completed_with_note")}
      </span>
    );
  }

  return <span className={`status-badge status-${status}`}>{t(status)}</span>;
};

export default StatusBadge;
